module.exports = __webpack_public_path__ + "static/media/55_000061.7250ea22.jpg";